import React from "react";
import "../Assets/css/index.css";
import Header from "./Layout/Header";
import Footer from "./Layout/Footer";
import { Link } from "react-router-dom";
import { useState } from "react";
import axiosMain from "../http/axiosMain";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Modal, Button } from "react-bootstrap";

function Contact() {

  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");  // For modal message
  const [isError, setIsError] = useState(false);  // Flag to determine success or error

  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      number: "",
      subject: "",
      role: "",
      message: "",
    },
    validationSchema: Yup.object({
      name: Yup.string()
        .matches(/^[a-zA-Z\s]+$/, "Only alphabets and spaces are allowed")
        .required("Please enter your name."),
      email: Yup.string()
        .email("Please enter a valid email address.")
        .matches(
          /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
          "Please enter a valid email address."
        )
        .required("Please enter your email."),
      number: Yup.string()
        .matches(/^\d{10}$/, "Phone number must be 10 digits.")
        .required("Please enter your phone number."),
      role: Yup.string().required("Please select whether you are a Brand or an Influencer."),
      message: Yup.string()
        .min(10, "Message should be at least 10 characters.")
        .max(500, "Message cannot exceed 500 characters.")
        .required("Please enter your message.")
        .test(
          "not-only-space",
          "Message cannot be just spaces",
          (value) => value && value.trim().length > 0
        ),
    }),
  });

  const wordCount = formik.values.message.trim().split(/\s+/).filter((word) => word.length > 0).length;

  // Function to handle the manual submit action
  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent default form submission
    await formik.validateForm(); // Validate form fields manually

    if (!formik.isValid) {
      formik.setTouched({
        name: true,
        email: true,
        number: true,
        role: true,
        message: true,
      });
      return; // Stop submission if the form is invalid
    }

    setShowModal(true); // Show modal confirmation if the form is valid
  };


  // Function to confirm and submit the form (trigger API call)
  const handleConfirmSubmit = async () => {
    const trimmedData = { ...formik.values, message: formik.values.message.trim() };

    try {
      console.log(trimmedData);
      await axiosMain.post("api/contactus/contacts", trimmedData);

      setModalMessage("Form submitted successfully!"); // Success message
      setIsError(false); // Set flag for success
      setTimeout(() => setModalMessage(""), 3000); // Clear message after 3 seconds

      formik.resetForm(); // Reset form after successful submission
    } catch (error) {
      console.error("Error submitting form", error);

      setModalMessage("Failed to submit the form. Please try again later."); // Error message
      setIsError(true); // Set flag for error
    }
  };


  // Function to handle cancel and close the modal
  const handleCancelSubmit = () => {
    setShowModal(false);  // Close the modal without submitting
  };

  return (
    <>
      <div className="contact-container">
        {/* Hero Section */}
        <div className="hero-section d-flex align-items-center justify-content-center">
          <div className="text-center">
            <h1 className="hero-title mt-auto">
              Where Connections Spark and Collaborations Begin
            </h1>
            <span className="text-light">
              <hr />
            </span>
          </div>
        </div>

        {/* Main Contact Section */}
        <div className="contact-content container p-5">
          <div className="row g-5">
            {/* Left Column */}
            <div className="col-lg-6 col-md-6 col-xs-12 col-sm-5">
              <h3 className="section-title Title">
                We’d Love to Hear From You!
              </h3>
              <p className="description">
                Whether you have a question, a project in mind, or just want to
                say hello, we're here for you. Reach out to us and let's start
                something amazing together!
              </p>
              <h5 className="get-in-touch ">Get in Touch</h5>
              <ul className="contact-info">
                <li>
                  <span className="contact-label">Email : </span>
                  <Link
                    href="mailto:support@insocialorbit.com"
                    className="contact-email"
                    style={{
                      color: " rgba(107, 142, 118, 1)",
                      textDecoration: "none",
                    }}
                  >
                    support@insocialorbit.com
                  </Link>
                </li>

                <li>
                  <span className="contact-label">Phone : </span>
                  <Link
                    style={{
                      color: "rgba(107, 142, 118, 1)",
                      textDecoration: "none",
                    }}
                    to="tel:+919426026611"
                  >
                    +91 94260 26611
                  </Link>
                </li>

                <li>
                  <span className="contact-label">Address : </span> 6, Rajpath
                  Rangoli Rd, PRL Colony, Bodakdev, Ahmedabad, Gujarat 380059
                </li>
                <li>
                  <span className="contact-label">Hours : </span> Open & Close
                  Time
                </li>
              </ul>
            </div>

            {/* Right Column */}
            <div className="col-lg-6 col-md-6 col-xs-12 col-sm-7">
              <div className="map-container">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7343.33802801375!2d72.48093469357907!3d23.035922000000024!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395e9bfa4c41c8d3%3A0x8f07c10faafa4242!2sInSocial%20Orbit%20Pvt.Ltd!5e0!3m2!1sen!2sin!4v1736161027572!5m2!1sen!2sin"
                  width="100%"
                  height="300px"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Google Map Location"
                ></iframe>
              </div>
            </div>
          </div>
        </div>

        {/* Form Section */}
        <div className="form-section p-5">
          <div className="container">
            <div className="form-title">
              <div className="title text-left mb-4">Connect with us</div>
            </div>
            <form className="connect-form" onSubmit={formik.handleSubmit}>
              <div className="row g-3">
                <div className="col-lg-6">
                  <label htmlFor="name" className="form-label">
                    Name <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="name"
                    placeholder="Enter your full name"
                    value={formik.values.name}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    required
                  />
                  {formik.touched.name && formik.errors.name ? (
                    <div className="error">{formik.errors.name}</div>
                  ) : null}
                </div>

                <div className="col-lg-6">
                  <label htmlFor="email" className="form-label">
                    Email <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="email"
                    className="form-control"
                    id="email"
                    placeholder="Enter your email address"
                    value={formik.values.email}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    required
                  />
                  {formik.touched.email && formik.errors.email ? (
                    <div className="error">{formik.errors.email}</div>
                  ) : null}
                </div>

                <div className="col-lg-6">
                  <label htmlFor="number" className="form-label">
                    Phone  <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="number"
                    placeholder="Enter your Phone Number"
                    value={formik.values.number}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    maxLength="10"
                    required
                  />
                  {formik.touched.number && formik.errors.number ? (
                    <div className="error">{formik.errors.number}</div>
                  ) : null}
                </div>

                <div className="col-lg-6">
                  <label htmlFor="subject" className="form-label">
                    Subject
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="subject"
                    placeholder="Enter your Subject"
                    value={formik.values.subject}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                </div>

                <div className="col-md-3">
                  <label className="form-label">
                    You are?<span style={{ color: "red" }}>*</span>
                  </label>
                  <div className="d-flex">
                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="role"
                        id="brand"
                        value="brand"
                        checked={formik.values.role === "brand"}
                        onClick={() => {
                          // Toggle between 'brand' and null if clicked again
                          if (formik.values.role === "brand") {
                            formik.setFieldValue("role", ""); // Deselect if the same option is clicked
                          } else {
                            formik.setFieldValue("role", "brand");
                          }
                        }}
                        style={{
                          backgroundColor: formik.values.role === "brand" ? "green" : "white",
                          borderColor: formik.values.role === "brand" ? "green" : "black",
                        }}
                      />
                      <label className="form-check-label" htmlFor="brand">
                        Brand
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="role"
                        id="influencer"
                        value="influencer"
                        checked={formik.values.role === "influencer"}
                        onClick={() => {
                          // Toggle between 'influencer' and null if clicked again
                          if (formik.values.role === "influencer") {
                            formik.setFieldValue("role", ""); // Deselect if the same option is clicked
                          } else {
                            formik.setFieldValue("role", "influencer");
                          }
                        }}
                        style={{
                          backgroundColor: formik.values.role === "influencer" ? "green" : "white",
                          borderColor: formik.values.role === "influencer" ? "green" : "black",
                        }}
                      />
                      <label className="form-check-label" htmlFor="influencer">
                        Influencer
                      </label>
                    </div>
                  </div>
                  {formik.touched.role && formik.errors.role ? (
                    <div className="error" style={{ width: "max-content", marginTop: "-2px" }}>
                      {formik.errors.role}
                    </div>
                  ) : null}
                </div>


                <div className="col-md-12 message" style={{ position: "relative" }}>
                  <label htmlFor="message" className="form-label">
                    Your Message (describe your query) <span style={{ color: "red" }}>*</span>
                  </label>
                  <textarea
                    className="form-control"
                    id="message"
                    rows="5"
                    placeholder="Type your message here..."
                    value={formik.values.message}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    style={{ paddingBottom: "30px" }}
                  ></textarea>
                  <div
                    style={{
                      position: "absolute",
                      bottom: "6px",
                      right: "15px",
                      fontSize: "14px",
                      color: "gray",
                      pointerEvents: "none",
                    }}
                  >
                    {wordCount}/500
                  </div>
                  {formik.touched.message && formik.errors.message ? (
                    <div className="error" style={{ marginTop: "4px" }}  >{formik.errors.message}</div>
                  ) : null}
                </div>

                <div className="col-12 text-center mt-5">
                  <button type="button" className="btn btn-success px-4" onClick={handleSubmit}>Submit</button>
                </div>

                {/* Modal for confirmation */}
                <Modal show={showModal} onHide={handleCancelSubmit} centered>
                  <Modal.Body className="text-center">
                    <h5>Are you sure you want to submit?</h5>

                    {/* Show dynamic success/error message */}
                    {modalMessage && (
                      <h5 className={isError ? "text-danger" : "text-success"}>{modalMessage}</h5>
                    )}

                    <div className="mt-4">
                      <Button
                        variant="success"
                        onClick={handleConfirmSubmit}
                        className="me-2"
                        style={{ backgroundColor: "rgba(107, 142, 118, 1)" }}
                      >
                        Submit
                      </Button>

                      <Button
                        variant="secondary"
                        onClick={handleCancelSubmit}
                        style={{ border: "1px solid gray" }}
                      >
                        Close
                      </Button>
                    </div>
                  </Modal.Body>
                </Modal>

              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default Contact;
